import ConfirmDeleteFileModal from './ConfirmDeleteFileModal'

export default ConfirmDeleteFileModal
export * from './ConfirmDeleteFileModal'
